import { memo, useReducer } from "react";
import { StateProp } from "../types";
import { initial_tooltip, tooltipReducer } from "./reducer";
import TooltipContext from "./context";

const TooltipState = memo(({ children }: StateProp) => {
  const [tooltip, dispatch] = useReducer(tooltipReducer, initial_tooltip)

  return (
    <TooltipContext.Provider value={{ tooltip, dispatch }}>
      {children}
    </TooltipContext.Provider>
  )
})

export default TooltipState
